/** biome-ignore-all lint/a11y/useValidAnchor: Needed for Onetrust*/
'use client';

import { Image } from '@/app/_components/common/Image';
import { Link } from '@/app/_components/common/Link';
import { DescriptionParser } from '@/app_lib/htmlParser/DescriptionParser';

interface NdrFooterProps {
  footerContent: string;
  className?: string;
}

export const NdrFooter = ({ footerContent, className = '' }: NdrFooterProps) => {
  const handleOptanonToggle = () => {
    if (typeof window !== 'undefined' && window.Optanon?.ToggleInfoDisplay) {
      window.Optanon.ToggleInfoDisplay();
    }
  };

  return (
    <footer
      className={`w-full bg-neutral-100 layout-safe-area p-xl ${className}`}
      data-cy='ndr-footer'
    >
      <div className='container-ft px-lg mx-auto'>
        <Link href='https://fortune.com/'>
          <Image
            alt='NDR Logo'
            className='mx-auto h-auto mb-10'
            data-cy='ndr-footer-logo'
            height={32}
            priority
            src='/static/ndr/logo.svg'
            width={139}
          />
        </Link>
        <div className='typography-level-6 leading-relaxed flex flex-col gap-10 text-neutral-900 [&_i]:text-base'>
          <div
            className='container-content mx-auto [&_span]:flex [&_span]:flex-col [&_span]:layout-gap-md'
            data-cy='ndr-footer-description'
          >
            <DescriptionParser content={footerContent} />
          </div>
          <div
            className='text-base text-center '
            data-cy='ndr-footer-copyright'
          >
            <p>© {new Date().getFullYear()} Fortune Media. All Rights Reserved.</p>
            <p className='text-xs tracking-[1px] text-center text-neutral-600 mt-4 font-graphik-condensed'>
              Use of this site constitutes acceptance of our{' '}
              <Link
                className='text-blue-600 hover:text-blue-800 underline'
                href='https://fortune.com/terms-of-use/'
              >
                Terms of Use
              </Link>{' '}
              and{' '}
              <Link
                className='text-blue-600 hover:text-blue-800 underline'
                href='https://fortune.com/privacy-policy/'
              >
                Privacy Policy
              </Link>{' '}
              |{' '}
              <Link
                className='text-blue-600 hover:text-blue-800 underline'
                href='/california-privacy-policy/#notice'
              >
                CA Notice at Collection and Privacy Notice
              </Link>{' '}
              | {/** biome-ignore assist/source/useSortedAttributes: needed for onetrust popup*/}
              <button
                type='button'
                onClick={handleOptanonToggle}
                className='text-blue-600 hover:text-blue-800 underline cursor-pointer'
                data-cy='privacy-preferences-link'
              >
                Do Not Sell/Share My Personal Information
              </button>
              <br />
              FORTUNE is a trademark of Fortune Media IP Limited, registered in the U.S. and other countries. FORTUNE
              may receive compensation for some links to products and services on this website. Offers may be subject to
              change without notice.{' '}
              <Link
                className='text-blue-600 hover:text-blue-800 underline'
                href='https://www.intercontinentalexchange.com/terms-of-use'
              >
                Terms & Conditions
              </Link>
              . Powered and implemented by{' '}
              <Link
                className='text-blue-600 hover:text-blue-800 underline'
                href='https://www.interactivedata.com/idms'
              >
                Interactive Data Managed Solutions
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
